module.exports = __webpack_public_path__ + "img/header-weddingRingsMen@2x.7648cf9.webp";